// extracted by mini-css-extract-plugin
export default {"root":"LineChart-root-b706","graphTitle":"LineChart-graphTitle-a797"};